<template>
  <div id="more-buttons">
    <v-menu left offset-y class="more-buttons-menu" content-class="elevation-2">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          small
          color="darkBackgroundGrey"
          class="ml-2 mr-0 elevation-0 more-buttons-menu-button"
          :loading="loading"
          v-on="on"
        >
          <span v-if="!isMobile && text" class="mr-1 more-buttons-text">{{ text }}</span>
          <v-icon :size="isMobile ? 22 : 20" class="more-buttons-icon" color="darkTextGrey">
            {{ !isMobile && text ? 'mdi-chevron-down' : 'mdi-dots-horizontal' }}
          </v-icon>
        </v-btn>
      </template>

      <v-list nav class="more-buttons-list">
        <div v-for="(item, i) in buttons">
          <v-list-item
            :key="i"
            :class="{
              'py-0 pl-3 pr-4': !item.actionable,
              'pb-0 pt-1 pl-3 pr-0 d-flex justify-space-between align-center': item.actionable,
            }"
            :disabled="item.disabled"
            @click="(event) => handleAction(item, event)"
          >
            <v-list-item-title>
              <v-icon size="18" class="mr-3 more-buttons-icon">
                {{ item.icon }}
              </v-icon>
              <span>{{ item.title }}</span>
            </v-list-item-title>

            <template v-if="item.actionable === 'switch'">
              <v-switch
                hide-details
                dense
                inset
                class="px-0 py-0 my-0 mr-0 ml-4"
                @change="item.action"
              />
            </template>
          </v-list-item>

          <v-divider v-if="item.divider && item.divider === 'bottom'" class="my-2"></v-divider>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState(['user']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    handleAction(item, event) {
      if (item.actionable) {
        event.stopPropagation()
      } else {
        item.action()
      }
    },
  },
}
</script>

<style lang="scss">
.more-buttons-list {
  .more-buttons-icon {
    margin-bottom: 3px;
  }
  .v-list-item {
    min-height: 35px !important;
  }
}
#more-buttons {
  .more-buttons-menu-button {
    margin-top: 1px;
    height: 28px;
    .v-btn__loader {
      color: #636363;
    }
  }
  .more-buttons-icon {
    margin-bottom: 1px;
  }
  .more-buttons-text {
    color: black;
  }
}
</style>
